import React, { useEffect, useContext, useState } from "react";
import { AuthContext } from '../../contexts/auth';
import { useParams } from 'wouter';
import { Popover } from '@headlessui/react';
import { getAlertDetail, setAlertRead } from "../../services/api_dipendenti";
import Fetching from "../../components/fetching";
import moment from "moment";
import Footer from "../../components/footer";
import BackButton from "../../components/back_button";
import { useLocation, Link } from 'wouter';



export default function ArSingleMessage() {
    const { token } = useContext(AuthContext);
    const { resourceId } = useParams();
    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [location] = useLocation();
    const queryParams = new URLSearchParams(window.location.search);
    const type = queryParams.get('type') || 'Comunicazioni';
       

    useEffect(() => {
      const fetchMessage = async () => {
        try {
          const response = await getAlertDetail(token, resourceId);
          setMessage(response);

          if (response && !response.is_read) {
            try {
              await setAlertRead(token, resourceId);
            } catch (setAlertReadError) {
              console.error('Error marking alert as read:', setAlertReadError);
            }
          }
            setIsLoading(false);
          } catch (error) {
            console.error('Error fetching message:', error);
            setIsError(true);
            setIsLoading(false);
          }
        };
    
        fetchMessage();
      }, [token, resourceId]);
    
      if (isLoading) {
        return <Fetching />;
      }
    
      if (isError || !message) {
        return (
          <div className="px-4 sm:px-6 lg:px-8 mt-5">
            <p className="text-red-500">Si è verificato un errore durante il caricamento del messaggio.</p>
          </div>
        );
      }
    
      return (
        <div>
          <Popover as="header" className={`bg-indigo-200`}>
            <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
              <div className="relative flex flex-wrap items-center justify-center lg:justify-between">
                <div className="w-full -5 lg:border-t lg:border-white lg:border-opacity-20">
                  <div className="flex justify-center my-2 py-2">
                    <h2 className="text-center text-2xl font-semibold text-indigo-800">
                      Messaggio
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </Popover>

          <div className="px-4 sm:px-6 lg:px-8 mt-5">
            <div className="flex justify-end w-full mb-6">
              <Link to={`/areariservata/avvisi?type=${type}`} className="border block rounded-md bg-grey-400 px-3 py-2 mr-2 text-center text-sm font-semibold text-grey-800 shadow-sm hover:bg-grey-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-600">
                Torna indietro
              </Link>
            </div>
            <div className="bg-white shadow overflow-hidden sm:rounded-lg">
              <div className="px-4 py-5 sm:px-6 bg-gray-50">
                <h3 className="text-lg leading-6 font-medium text-gray-900">{message.title}</h3>
                <p className="mt-1 max-w-2xl text-sm text-gray-500">{moment(message.created_at).format('DD/MM/YYYY HH:mm')}</p>
              </div>
              <div className="border-t border-gray-200">
                <dl>
                  <div className="px-4 py-5">
                    <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{message.message}</dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
          <div className="pt-8">
            <Footer />
          </div>
        </div>
    );
}